export default (superClass) => {
    return class extends superClass {
        get aviFeePaperInvoice() {
            return this._data.avi_fee_paper_invoice; 
        }
    
        get aviFeeEInvoice() {
            return this._data.avi_fee_e_invoice; 
        }

        /**
         * @param template should include {paperInvoiceFee} and {eInvoiceFee}
         * @returns String
         */
        getAviFeeString(template = '{paperInvoiceFee} ({eInvoiceFee} e-faktura)') {

            if(this.aviFeeEInvoice == 0 && this.aviFeePaperInvoice == 0) {
                return this.formatCurrency(0);
            }

            if(this.aviFeeEInvoice == this.aviFeePaperInvoice) {
                return this.formatCurrency(this.aviFeePaperInvoice);
            }

            return template
                .replace('{paperInvoiceFee}', this.formatCurrency(this.aviFeePaperInvoice))
                .replace('{eInvoiceFee}', this.formatCurrency(this.aviFeeEInvoice));
        }
    }
}